export const QUERY_PARAMS_FEATURE_KEY = 'query-params';